import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import TextBox from 'components/common/text_box'
import styles from './edit_description.less'
import { DESCRIPTION_LENGTH, DESCRIPTION_ROWS } from 'shared/lengths'
import EditForm from '../edit_form'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'
import TipBox from 'components/common/tip_box'
import { HeadingText } from '@paypalcorp/pp-react'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

const i18n = getI18n('components/edit_glimpse/edit_description')

class EditDescription extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    fields: PropTypes.object.isRequired,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    campaignType: PropTypes.string,
  }

  render() {
    const {
      fields: { description },
      anyInactiveFieldsTouchedWithError,
      campaignType,
    } = this.props

    return (
      <EditForm {...this.props}>
        {campaignType === CROWD_FUNDING ? (
          <HeadingText size="md" styleName="title_cf">
            {i18n('title_cf')}
          </HeadingText>
        ) : (
          <div>
            <div styleName="title" role="heading" aria-level="1">
              {i18n('title')}
            </div>
            <div styleName="subtitle" role="heading" aria-level="2">
              {i18n('subtitle')}
            </div>
          </div>
        )}

        <TextBox
          data-pa-focus="description"
          {...description}
          multiline={true}
          rows={DESCRIPTION_ROWS}
          title={i18n(
            campaignType === CROWD_FUNDING ? 'description_title' : 'description'
          )}
          maxLength={DESCRIPTION_LENGTH}
          autoFocus={true}
        />
        {campaignType === CROWD_FUNDING && (
          <TipBox text={i18n('description_subtitle')} />
        )}
        <button
          data-pa-click="save"
          className={`vx_btn vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          styleName="save-button"
        >
          {i18n('save')}
        </button>
      </EditForm>
    )
  }
}

export default cssModules(EditDescription, styles)
